import React from 'react';
// import { Carousel } from 'react-responsive-carousel';

class Mantra1_5_canvas extends React.Component {

    render() {

        let { image, name, festival_name } = this.props;

        return (
            <section className="gen_section05 setdiv_canvas" id={"canvas_generate_" + this.props.module_name}>
                <div className="card_content05" >
                    <img src={image} className="img-fluid" alt="" />
                    <h4>{name}</h4>
                    <h5>{festival_name}</h5>
                    {/* <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1488</span></h6> */}
                </div>
            </section>
        )
    }
}

export default Mantra1_5_canvas;